module.exports = function() {
  return new Worker(__webpack_public_path__ + "baeccd746dd93e160bc7.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./src/services/templateWorker.js
// module id = 2071
// module chunks = 1